// src/Pages/DetailedServices/DetailedServices.jsx
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';
import joinImage from '../../assets/sinunkortti.png'; // korvaa tiedostonimelläsi

import transportImage from '../../assets/perakarry.png'; // Korvaa omalla kuvallasi
import opastusImage from '../../assets/xlr.jpg'; // Korvaa omalla kuvallasi
import valoaaniImage from '../../assets/valojaani.jpg'; // Korvaa omalla kuvallasi
import banditImage from '../../assets/bandit.jpeg'; // Korvaa omalla kuvallasi
import ResponsiveButton from '../../components/ResponsiveButton/ResponsiveButton';
import { MdArrowBack } from 'react-icons/md';

const DetailedServices = () => {
  const { hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // AOS käynnistyy
    AOS.init({ duration: 1000, once: true });
  
    // Vieritys hash-ankkuriin
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100); // pieni viive DOMin varmistamiseksi
      }
    }
  }, [hash]);
  
  

  useEffect(() => {
    const scrollToHash = () => {
      if (location.hash) {
        const element = document.querySelector(location.hash);
        if (element) {
          // Käytä pientä viivettä, että DOM ehtii piirtyä
          setTimeout(() => {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 100);
        }
      }
    };
  
    scrollToHash();
  }, [location]);

  return (
    <>
      <Helmet>
  <title>Spiderlegs Productions | Palvelut – lisätiedot</title>
  <meta
    name="description"
    content="Tarkat tiedot Spiderlegs Productionsin kuljetus-, asennus-, opastus-, äänentoisto- ja esiintyjäpalveluista. Lue lisää palveluistamme ja varaa oma pakettisi."
  />
  <meta
    name="keywords"
    content="kuljetuspalvelu, asennuspalvelu, opastuspalvelu, äänentoisto, esitystekniikka, bändit, esiintyjät, Spiderlegs Productions"
  />
  <meta property="og:title" content="Spiderlegs Productions | Palvelut – lisätiedot" />
  <meta
    property="og:description"
    content="Tarkat tiedot Spiderlegs Productionsin palveluista – kuljetus, asennus, opastus, äänentoisto ja esiintyjät. Lue lisää ja varaa palvelusi."
  />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://spiderlegsproductions.com/detailedservices" />
  <meta property="og:image" content="https://spiderlegsproductions.com/assets/new_logo.webp" />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Spiderlegs Productions | Palvelut – lisätiedot" />
  <meta
    name="twitter:description"
    content="Tarkat tiedot Spiderlegs Productionsin palveluista – kuljetus, asennus, opastus, äänentoisto ja esiintyjät."
  />
  <meta name="twitter:image" content="https://spiderlegsproductions.com/assets/new_logo.webp" />
  <link rel="canonical" href="https://spiderlegsproductions.com/detailedservices" />
</Helmet>


      <div className="max-w-7xl mx-auto p-4 bg-primary dark:bg-violet bg-opacity-75 dark:bg-opacity-75 rounded-lg shadow-md min-h-screen text-darkest dark:text-primary pt-28">
      {/* Takaisin-nappi */}
               <ResponsiveButton onClick={() => navigate(-1)} variant="backbutton">
                 <div className="flex items-center gap-2">
                   <MdArrowBack className="text-xl" />
                   <span className="xxxsm:text-sm text-sm sm:text-base md:text-lg">Takaisin</span>
                 </div>
               </ResponsiveButton>

        {/* Otsikko H1 */}
        <h1 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary text-5xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-[1.2] mb-8 pt-8">
          Palveluiden lisätiedot
        </h1>

        <section id="kuljetuspalvelu" className="mb-16 scroll-mt-44" data-aos="fade-up">
          <h3 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary text-4xl font-bold leading-tight mb-6">
            Kuljetuspalvelu & kuomukärryn vuokraus
          </h3>

          <div className="flex flex-col lg:flex-row gap-8">
          <div className="w-full lg:w-1/2">
            <img
              src={transportImage}
              alt="Kuljetuspalvelu"
              data-aos="fade-right"
              className="w-full lg:w-96 lg:float-right lg:ml-8 mb-4 rounded-lg"
            />
          </div>


            <div className="w-full lg:w-1/2 font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light space-y-5">
              <p>
                Spiderlegs Productions tarjoaa joustavan kuljetuspalvelun tapahtumiin ja muihin tarpeisiin. Voit tilata laitteet toimitettuna, noutaa ne itse – tai vuokrata pelkän <strong>HIRVI 350 -kuomukärryn</strong> mihin tahansa kuljetustarpeeseen.
              </p>

              <p>
                🚗 <strong>Henkilöautokuljetus:</strong> Mikäli vuokrakalusto mahtuu henkilöautoon, veloitus perustuu
                <a
                  href="https://www.vero.fi/henkiloasiakkaat/vahennykset/kilometrikorvaus-ja-paivaraha/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline ml-1"
                >
                  voimassa olevaan kilometrikorvaukseen.
                </a>
              </p>

              <p>
                🚛 <strong>Peräkärryllä toimitus:</strong> Jos kuljetus vaatii suuremman kaluston, veloitetaan kilometrikorvauksen lisäksi <strong>20 € kärrymaksu per suunta</strong>.
              </p>

              <p>
                🛻 <strong>Itse nouto:</strong> Voit noutaa itse vuokraamasi laitteet tai vuokrata käyttöösi HIRVI 350 -kuomukärryn. 
                Vuokraus onnistuu helposti <a
                href="tuote/hirvi-350-kuomukarry#kalenteri"
                className="underline text-linkcol hover:text-accent transition"
              >kalenterista,</a> valitse vain vapaa ajankohta ja nouda se turvallisesti Keravalta. 
                Kärry voidaan myös toimittaa haluamaasi osoitteeseen erillistä maksua vastaan.
              </p>
            </div>
          </div>

       {/* Vuokrausehdot */}
<div id="vuokrausehdot" className="scroll-mt-44 mt-12 space-y-6">
  <h4 className="text-3xl font-customFont2 dark:text-shadow-xxl text-darkest dark:text-primary font-bold mb-4">
    Vuokrausehdot & käyttöohjeet
  </h4>

  <div className="space-y-6">

    {/* 1. Varaus ja peruutukset */}
    <div>
      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-bold">
        Varaus ja peruutukset
      </p>
      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light">
        <strong>Maksettu varaus on sitova.</strong> Varausta ei voi perua tai siirtää sen jälkeen, kun maksu on suoritettu.
        Varmistathan siis nouto- ja palautusajan ennen maksua.
      </p>
    </div>

    {/* 2. Vuokra-aika */}
    <div>
      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-bold">
        Vuokra-aika
      </p>
      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light">
        Vuokra alkaa noutohetkestä ja päättyy palautukseen. Mikäli kärryä ei palauteta sovitusti eikä asiasta ole ilmoitettu,
        lisätään vuokrahintaan <strong>100 € myöhästymismaksu</strong> ja asiasta <strong>tehdään rikosilmoitus poliisille</strong>.
      </p>
    </div>

    {/* 3. Luovutus ja palautus */}
    <div>
      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-bold">
        Luovutus ja palautus
      </p>
      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light">
        Nouto ja palautus tapahtuu <strong>Keravan Saviolla</strong>. Avainlokeron koodi ja tarkka osoite toimitetaan sähköpostitse varauksen vahvistuksen jälkeen.
        Alueella on <strong>tallentava videovalvonta</strong>.
      </p>
    </div>

    {/* 4. Kuormaus & turvallisuus */}
    <div>
      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-bold">
        Kuormaus & turvallisuus
      </p>
      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light">
        Ylikuormaaminen on kielletty. Vuokraaja vastaa kuorman kiinnityksestä ja liikennesääntöjen noudattamisesta.
        <strong> Aisalukko on pakollinen</strong> ja se toimitetaan kärryn mukana.
      </p>
    </div>

    {/* 5. Vastuu ja vahingot */}
    <div>
      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-bold">
        Vastuu ja vahingot
      </p>
      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light">
        Vuokraaja on vastuussa kaikista vuokra-aikana sattuvista vaurioista ja kustannuksista, kuten <strong>rengasrikoista</strong>,
        <strong> pysäköinti- ja liikennesakoista</strong> sekä <strong>huolimattomuudesta</strong> aiheutuneista vahingoista.
        Mikäli peräkärry <strong>tuhoutuu tai katoaa huolimattoman tai lainvastaisen käytön seurauksena</strong>,
        vuokraaja on velvollinen korvaamaan sen <strong>täyden uushankinta-arvon</strong>.
      </p>
      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light mt-3">
        Vuokralleantajalla on oikeus veloittaa erikseen mahdolliset <strong>puhdistus- ja kunnostuskulut</strong>,
        mikäli kärry palautetaan <strong>likaisena tai vaurioituneena</strong>. Vuokraaja vastaa aina itse kuljetettavasta omaisuudesta sekä mahdollisista onnettomuuksista.
      </p>
      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg xl:text-xl font-light mt-3">
        Vuokraaja hyväksyy, että hänen henkilötietonsa voidaan luovuttaa <strong>viranomaisille</strong> tai esimerkiksi
        <strong> pysäköinninvalvontayrityksille</strong>, mikäli vuokrauksen yhteydessä syntyy maksamattomia sakkoja tai maksuja (esim. automaattinen kameravalvonta).
      </p>
    </div>
  </div>
</div>


        </section>




        {/* Asennus- ja opastuspalvelu */}
        <section id="opastuspalvelu" className="mb-16 scroll-mt-48" data-aos="fade-up">
          <h3 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight mb-6">
            Asennus- ja opastuspalvelu
          </h3>
          <div className="flex flex-col-reverse lg:flex-row items-center gap-8 mb-6">
            <div className="w-full lg:w-1/2">
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light mb-4" data-aos="fade-right">
                Spiderlegs Productions tarjoaa laitteiden vuokraajille <strong>asennus- ja opastuspalvelun</strong> tapahtumapaikalla, mikäli toimitusehtona on kuljetus. Palvelu sisältyy kuljetuksen yhteyteen automaattisesti.
              </p>
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light mb-4" data-aos="fade-right">
                Asennamme vuokrattavat laitteet paikan päällä <strong>toimintavalmiiksi</strong> ja varmistamme, että kaikki toimii kuten pitää. Saat selkeät ja käytännönläheiset <strong>käyttöohjeet</strong>, jotta voit keskittyä itse tapahtumaan ilman turhaa stressiä tekniikasta.
              </p>
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light" data-aos="fade-right">
                Tämä palvelu sopii erityisesti sinulle, joka et halua itse kytkeä johtoja tai miettiä, miten valot tai miksauspöytä toimii – me hoidamme sen puolestasi.
              </p>
            </div>
            <div className="w-full lg:w-1/2" data-aos="fade-left">
              <img
                src={opastusImage}
                alt="Laitteiden asennus ja opastus"
                className="w-full rounded-xl shadow-lg"
              />
            </div>
          </div>
        </section>

        {/* Koko illan tekninen toteutus */}
        <section id="valojaanen" className="mb-16 scroll-mt-48" data-aos="fade-up">
          <h3 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight mb-6">
            Koko illan tekninen toteutus
          </h3>
          <div className="flex flex-col lg:flex-row items-center gap-8 mb-6">
            <div className="w-full lg:w-1/2" data-aos="fade-right">
              <img
                src={valoaaniImage}
                alt="Äänentoisto ja esitystekniikka"
                className="w-full rounded-xl shadow-lg"
              />
            </div>
            <div className="w-full lg:w-1/2" data-aos="fade-left">
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light mb-4">
                Tämä palvelu tarkoittaa, että Spiderlegs hoitaa <strong>koko tapahtuman äänentoiston, tunnelmavalaistuksen ja muun esitystekniikan</strong> alusta loppuun – suunnittelusta toteutukseen.
              </p>
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light mb-4">
                Me tuomme paikalle <strong>kaikki tarvittavat laitteet</strong>, asennamme ne valmiiksi ja <strong>olemme paikalla koko tapahtuman ajan</strong> varmistamassa, että kaikki toimii moitteettomasti – myös tilanteiden muuttuessa lennossa.
              </p>
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light mb-4">
                Tapahtuman päätyttyä <strong>viemme laitteet pois puolestasi</strong>, tai sopimuksen mukaan seuraavana päivänä. Sinä voit keskittyä itse juhlaan.
              </p>
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light" data-aos="fade-up">
                <strong>Muista mainita tästä palvelusta yhteydenottolomakkeella</strong>, jotta osaamme varata riittävän ajan ja suunnitella toteutuksen huolellisesti. Tämä on loistava valinta, kun haluat <strong>stressivapaat juhlat</strong> ja varmuuden siitä, että tekniikka toimii ammattimaisesti koko illan.
              </p>
            </div>
          </div>
        </section>

       {/* Bändit & Esiintyjät */}
<section id="bandit" className="mb-16 scroll-mt-48" data-aos="fade-up">
  <h3 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary 
      xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl 
      font-bold leading-tight mb-6">
    Bändit &amp; Esiintyjät
  </h3>

  <div className="flex flex-col-reverse lg:flex-row gap-8 my-4">
    {/* Tekstit vasemmalle */}
    <div className="w-full lg:w-1/2" data-aos="fade-right">
      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary 
        xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light mb-4">
        Etsitkö esiintyjää juhliin, häihin, yritystapahtumaan tai illanviettoon? Spiderlegs Productionsin kautta buukkaat <strong>ammattitaitoiset bändit ja trubaduurit</strong> helposti ja nopeasti.
      </p>
      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary 
        xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light mb-4">
        Suodata hakutuloksia toiveidesi mukaan ja löydä juuri sinun tapahtumaasi sopiva esiintyjä. Voit myös ottaa suoraan yhteyttä ja kysyä suosituksia – autamme mielellämme!
      </p>
      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary 
        xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light" data-aos="fade-up">
        Haemme jatkuvasti verkostoomme lisää <strong>bändejä, trubaduureja, DJ:tä ja muita yhteistyökumppaneita</strong>. Mikäli haluat lisää esiintymisiä ja näkyvyyttä, <strong>ota rohkeasti yhteyttä</strong>.
      </p>
    </div>

    {/* Kuva oikealle isolla ruudulla, ensin pienellä */}
    <div className="w-full lg:w-1/2">
      <img
        src={banditImage}
        alt="Esiintyjät lavalla"
        data-aos="fade-left"
        className="w-full lg:w-96 lg:float-right lg:ml-8 mb-4 rounded-lg shadow-lg"
      />
    </div>
  </div>
  <div className="flex justify-center mt-8" data-aos="fade-up">
  <ResponsiveButton
    onClick={() => {
      navigate("/liity");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100); // pieni viive että varmistetaan navigointi ehtii
    }}
    variant="hero"
    className="text-lg px-6 py-3 rounded-full"
  >
    Liity esiintyjäksi
  </ResponsiveButton>
</div>

</section>

<section id="liity-vuokraajaksi" className="mb-16 scroll-mt-48" data-aos="fade-up">
  <h3 className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary 
      xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl 
      font-bold leading-tight mb-6">
    Liity vuokraajaksi
  </h3>

  <div className="flex flex-col lg:flex-row gap-8">
    {/* Kuva vasemmalle */}
    <div className="w-full lg:w-1/2" data-aos="fade-right">
      <img
        src={joinImage}
        alt="Liity vuokraajaksi"
        className="w-full rounded-xl shadow-lg"
      />
    </div>

    {/* Tekstit oikealle */}
    <div className="w-full lg:w-1/2 font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary 
      xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl font-light space-y-6">
     
      <p>
        Onko nurkissasi vanha miksauspöytä, rumpumikkejä, valopalkkeja tai muuta esiintymisten perintökamaa? 
        Kaikilla bändeillä ja muusikoilla kertyy varastoon yhtä sun toista – 
        <strong> laita ne töihin!</strong> Vuokraa ne Spiderlegs Productionsin kautta ja nappaa siinä sivussa vähän bensarahaa.
      </p>

      <p>
        Vuokraajana sinä päätät, milloin kamat ovat käytettävissä sekä voit määritellä milloin ne ovat saatavilla. 
        Kun joku tekee varauksen, sinun tehtäväsi on huolehtia, että laitteet ovat <strong>toimintakuntoisia ja noudettavissa sovitusti </strong> 
        tai vaihtoehtoisesti voit tarjota myös <strong>kuljetuksen asiakkaalle sopivaan hintaan</strong>.
      </p>

      <p>
        Mukaan pääsee helposti, mutta <strong>sitoudut vuokrausehtoihin</strong>, joissa sovitaan mm. laitteen kunnosta ja siitä, että ne löytyvät silloin kun asiakas niitä tarvitsee. 
        Tämä ei ole romunkeräyspalvelu – vaan tapa pistää käyttämättömät laitteet hommiin!
      </p>

      <p className="mt-4 italic">
        Enää ei tarvitse huudella somessa, kun <strong>rumpupenkki jäi treenikselle Kouvolaan</strong> – tsekkaa vuokrattavat kamat sivuiltamme ja <strong>vuokraa itsellesi palli keikalle</strong>. 😎
      </p>

      <div className="bg-white bg-opacity-30 border border-darkest dark:border-primary p-4 rounded-xl mt-8">
  <h4 className="text-xl font-bold mb-2 text-darkest dark:text-primary">Miten ansaitsen?</h4>
  <p className="text-darkest dark:text-primary font-light">
    Spiderlegs Productions veloittaa vain toteutuneista vuokrauksista – 
    <strong>provisio on 20 %</strong> per varaus. Jos tuot yli 100 € kuukaudessa, 
    provisio alenee automaattisesti <strong>10 prosenttiin</strong>. 
    Ei kiinteitä kuluja, ei piilomaksuja – vain helppo tapa pistää kalusto tuottamaan.
  </p>
</div>


      <p className="mt-6">
        <a 
          href="https://spiderlegsproductions.com/tee-varaus"
          className="underline text-linkcol hover:text-accent transition"
          target="_blank" 
          rel="noopener noreferrer"
        >
          👉 Ota yhteyttä ja ehdota laitteitasi!
        </a>
      </p>

    </div>
  </div>
</section>




      </div>
    </>
  );
};

export default DetailedServices;
